import React, { memo, FC } from 'react'

import { Box } from '@/components/VideoPlayer/styles'
import { dotSize, lineHeight } from '@/constants/common'

import { StyledDot, StyledLine, StyledProgressBar } from './styles'
import { TimeLabels } from './TimeLabels'

type Props = {
  currentTime?: number
  duration?: number
  dotColor?: string
  lineColor?: string
  lineBgColor?: string
  currentTimeOnly?: boolean
  numberOfSegments?: number
  currentSegment?: number
}

const AdProgressRaw: FC<Props> = ({
  currentTime = 0,
  duration = 0,
  dotColor = '#FFFFFF',
  lineColor = '#FFFFFF',
  lineBgColor = 'rgba(255,255,255,0.3)',
  currentTimeOnly = false,
  currentSegment = 1,
  numberOfSegments = 1,
}) => {
  return (
    <StyledProgressBar $marginLeft={0}>
      <Box>
        {[...new Array(numberOfSegments)].map((_, index) => {
          let percentage = ((currentTime / duration) * 100).toFixed(2)
          if (currentSegment - 1 > index) {
            percentage = '100'
          }
          if (currentSegment - 1 < index) {
            percentage = '0'
          }
          return (
            <StyledProgressBar $marginLeft={24} key={`progressbar${index}`}>
              <StyledLine
                $height={lineHeight}
                $color={lineBgColor}
                $fullWidth
              />
              <StyledLine
                $height={lineHeight}
                $color={lineColor}
                $percentage={percentage}
              />
              <StyledDot
                $size={dotSize}
                $color={dotColor}
                $percentage={percentage}
              />
            </StyledProgressBar>
          )
        })}
      </Box>
      <TimeLabels
        currentTime={currentTime}
        duration={duration}
        currentTimeOnly={currentTimeOnly}
      />
    </StyledProgressBar>
  )
}

export const AdProgress = memo(AdProgressRaw)
